<template>
  <div class="layout-menu">
    <div class="menus">
      <div class="menusBox">
        <div
          class="menu-item"
          :class="{ active: checkIsActive(item) }"
          v-for="item in newMenus"
          :key="item.id"
          @click="onMenuClick(item)"
          @mouseenter="mouseIn(item)"
        >
          <svg-icon
            v-if="item.icon"
            :icon-name="item.icon"
            icon-class="menu-icon"
            :active="item.code === current || mouseCurrent == item.code"
            iconColor="rgba(23, 150, 107, 1)"
          ></svg-icon>
          <div class="menu-label">{{ item.name }}</div>
          <div
            class="test"
            @mouseleave="mouseOut(item)"
            v-if="
              item.subMenusShow && item.children && item.children.length > 0
            "
          >
            <div class="itembox">
              <div
                class="sub-menu-item"
                :class="{ active: v.code === current }"
                v-for="(v, i) in item.children"
                :key="v.id"
                @click="onSubMenuClick(v)"
              >
                <div class="subMenusBg">
                  <div class="subMenusName">{{ v.name }}</div>
                </div>
                <div class="line" v-if="i != item.children.length - 1"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  props: {
    newMenus: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      mouseCurrent: "",
      current: "",
    };
  },
  watch: {
    newMenus: {
      handler(val) {
        if (val && val.length > 0) {
          this.current = val[0].code;
          localStorage.setItem("currentCode", this.current);
        }
      },
      immediate: true,
    },
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    checkIsActive(item) {
      if (item.code == this.current) {
        return true;
      }
      if (item.children && item.children.length > 0) {
        let arr = item.children.filter((v) => v.code == this.current);
        if (arr.length > 0) {
          return true;
        }
      }
      return false;
    },
    onMenuClick(payload) {
      if (payload.children && payload.children.length > 0) {
        payload.subMenusShow = true;
      } else {
        this.current = payload.code;
        this.onSubMenuClick(payload);
      }
    },
    mouseIn(payload) {
      this.newMenus.forEach((item) => {
        item.subMenusShow = false;
      });
      payload.subMenusShow = true;
    },
    mouseOut(payload) {
      payload.subMenusShow = false;
    },
    onSubMenuClick({ id, route, code }) {
      this.current = code;
      localStorage.setItem("currentCode", code);
      this.$emit("onMenuClick", { id: id, code });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-menu {
  position: absolute;
  top: 50%;
  width: 120px;
  transform: translateY(-50%);
  left: 4%;
  height: 560px;
  z-index: 2;

  .menus {
    position: absolute;
    background: url("~@/assets/images/layout/sideBorder.png") no-repeat;
    background-size: 100% 100%;
    width: 100px;
    padding: 10px;
    box-sizing: border-box;
    // .menusBox {
    //   max-height: 85vh;
    //   overflow-y: auto;
    // }
  }

  .menu-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    color: #10b37c;
    margin-top: 10px;
    border-radius: 6px;
    background: url("~@/assets/images/layout/sideItem.png") no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    font-weight: 700;
    position: relative;
    box-sizing: border-box;

    .test {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 95px;
      width: 230px;
      background: #072117;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3),
        inset 0px 4px 60px 0px #004a2e;
      border-radius: 6px;
      border: 2px solid #18997d;
      padding: 18px 10px;
      box-sizing: border-box;

      .itembox {
        display: flex;
        flex-direction: column;
        max-height: 250px;
        overflow-y: auto;
        min-height: 50px;
      }

      .triangle {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;
        border-left: 10px solid transparent;
        border-right: 10px solid #18997d;
        position: absolute;
        left: -20px;
        // top: min(50%,50px);
        top: 50%;
        transform: translateY(-50%);

        &::after {
          content: "";
          display: block;
          width: 0;
          height: 0;
          border-top: 10px solid transparent;
          border-bottom: 10px solid transparent;
          border-left: 10px solid transparent;
          border-right: 10px solid #033623;
          position: absolute;
          left: 0;
          top: 0;
          transform: translate(-7px, -10px);
        }
      }
    }

    &:last-of-type {
      margin-bottom: 0;
    }

    &:hover,
    &.active {
      background: url("~@/assets/images/layout/sideitemActive.png") no-repeat;
      background-size: 100% 100%;

      .menu-label {
        font-family: HarmonyOS_Sans_SC_Bold, serif;
        background: linear-gradient(180deg, #fff09e 18%, #11c58c 90%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }
    }
  }

  .menu-icon {
    font-size: 20px;
    margin-right: 0;
    margin-bottom: 8px;
  }

  .menu-label {
    font-family: HarmonyOS_Sans_SC_Bold, serif;
    font-size: 16px;
  }

  .sub-menus {
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    padding: 10px;
    margin-left: 100px;
    border-radius: 6px;
    background: #072117;

    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3),
      inset 0px 4px 60px 0px #004a2e;
  }

  .sub-menu-item {
    font-size: 16px;
    color: #fff;
    padding: 0 20px;
    padding-left: 10px;
    color: #17966b;
    transition: all 500ms;
    cursor: pointer;

    .line {
      background: linear-gradient(
        90deg,
        rgba(160, 235, 154, 0.2) -2%,
        rgba(160, 235, 154, 0) 98%
      );
      height: 1px;
      margin: 8px 0;
    }

    &.active,
    &:hover {
      .subMenusName {
        background: linear-gradient(180deg, #fff09e 50%, #11c58c 90%);
        -webkit-background-clip: text;
        background-clip: text;
        color: transparent;
      }

      .subMenusBg {
        background-image: linear-gradient(
          90deg,
          rgba(160, 235, 154, 0.2) -2%,
          rgba(160, 235, 154, 0) 98%
        );
      }
    }

    .subMenusName {
      line-height: 24px;
    }
  }
}
</style>